import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { StandardTriageRecommendationPageEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageRecommendationPageEventTracking';
import { SegmentPropertyValue } from '@/integrations/segment/enums/SegmentPropertyValue';
import { VaultPlanType } from '@/modules/estate/constants/VaultPlanType';

export class StandardTriageRecommendationPageConsultationClickedEventTracking extends StandardTriageRecommendationPageEventTracking {
  static eventName: SegmentEvent =
    SegmentEvent.STANDARD_TRIAGE_RECOMMENDATION_PAGE_CONSULTATION_CLICKED;
  selected_product?: string;

  constructor(
    eventProperties: Partial<StandardTriageRecommendationPageConsultationClickedEventTracking>,
    type: string
  ) {
    super(eventProperties);
    this.selected_product =
      type === VaultPlanType.COMPLETE.key
        ? SegmentPropertyValue.COMPLETE
        : SegmentPropertyValue.PROFESSIONAL_EXECUTOR;
  }
}
